import React from 'react';
import { IconArrowDownLeft, IconArrowUpRight } from '@tabler/icons-react';
import { Transaction } from 'types';

interface StatsOverviewProps {
  transactions: Transaction[];
}

const StatsOverview: React.FC<StatsOverviewProps> = ({ transactions }) => {
  const now = new Date();
  const thisMonth = transactions.filter(txn => {
    const txnDate = new Date(txn.created_at);
    return txnDate.getMonth() === now.getMonth() && txnDate.getFullYear() === now.getFullYear();
  });
  const totalCredited = thisMonth.filter(txn => txn.direction === 'credit').reduce((sum, txn) => sum + parseFloat(txn.amount), 0);
  const totalDebited = thisMonth.filter(txn => txn.direction === 'debit').reduce((sum, txn) => sum + parseFloat(txn.amount), 0);
  const count = thisMonth.length;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-5 mb-8">
      <div className="bg-primary-50 rounded-xl border border-primary-100 shadow-sm p-4 sm:p-7 flex items-center min-h-[120px] sm:min-h-[140px]">
        <IconArrowDownLeft className="w-6 h-6 sm:w-7 sm:h-7 text-primary-400 mr-2 sm:mr-3" />
        <div>
          <div className="text-[10px] sm:text-xs text-gray-400">Credited this month</div>
          <div className="font-bold text-base sm:text-lg text-primary-600">
            ₦{totalCredited.toLocaleString()}
          </div>
        </div>
      </div>

      <div className="bg-blue-50 rounded-xl border border-blue-100 shadow-sm p-4 sm:p-7 flex items-center min-h-[120px] sm:min-h-[140px]">
        <IconArrowUpRight className="w-6 h-6 sm:w-7 sm:h-7 text-blue-400 mr-2 sm:mr-3" />
        <div>
          <div className="text-[10px] sm:text-xs text-gray-400">Debited this month</div>
          <div className="font-bold text-base sm:text-lg text-blue-600">
            ₦{totalDebited.toLocaleString()}
          </div>
        </div>
      </div>

      <div className="bg-primary-50 rounded-xl border border-primary-100 shadow-sm p-4 sm:p-7 flex items-center min-h-[120px] sm:min-h-[140px] col-span-2 sm:col-span-1">
        <div className="w-6 h-6 sm:w-7 sm:h-7 p-3 sm:p-4 rounded-md flex items-center justify-center mr-2 sm:mr-3 font-bold text-lg sm:text-2xl text-gray-600">
          {count}
        </div>
        <div>
          <div className="text-[10px] sm:text-xs text-gray-400">Transactions</div>
          <div className="font-bold text-base sm:text-lg text-gray-600">This month</div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview; 